import {AND, ARRAY, INTEGER, OBJECT, OPTIONAL, STRING} from '@acng/frontend-rubicon';
import {GALLERY_DATA} from '../../core/service/guard.js';

/**
 * Validate movie object from the ACNG-API.
 */
export const MOVIE_DATA = /* @__PURE__ */ AND(
  GALLERY_DATA,
  /* @__PURE__ */ OBJECT({
    id: INTEGER,
    filesize: INTEGER,
    playtime: INTEGER,
    width: INTEGER,
    height: INTEGER,
    movie_previews: OPTIONAL(ARRAY(STRING)),
  }),
);
